// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_e5-0";
export var actionModalContentContainer = "_e5-1";
export var createTagButton = "_e5-2";
export var footerContainer = "_e5-7";
export var fullWidthDivider = "_e5-3";
export var hasCreateTagButton = "_e5-4";
export var noCreateTagButton = "_e5-5";
export var tagsContainer = "_e5-6";
export var tagsModalContentContainer = "_e5-8";